module.exports = __webpack_public_path__ + "assets/img/star.609b6177.svg";